import HTTP from "../../http";

const EMAIL_ENDPOINT = "/email";
const FORGOT_PASSWORD_ENDPOINT = "/forgotPassword";

export async function forgotPassword(email, resetPasswordRoute) {
  // console.log(email);
  return await HTTP.post(
    EMAIL_ENDPOINT + FORGOT_PASSWORD_ENDPOINT,
    { email, resetPasswordRoute },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
